<template>
    <div :key="key">
        <div v-if="action.menu.can_edit">
            <b-input
                ref="duration"
                v-model="form.duration"
                size="sm"
                :class="reactiveClass"
                class="number-font font-weight-bold text-primary"
                style="cursor: pointer"
                @change="handleNewDuration"
            />
        </div>
        <div v-else>
            <span class="number-font">{{ form.duration }}</span>
        </div>
        <b-modal
            ref="apply-duration-modal"
            hide-footer
            title="Application de la durée saisie"
        >
            <p>
                A partir de quand souhaitez-vous appliquer cette durée sur les
                échéances ?
            </p>
            <b-input-group class="mb-3">
                <b-form-input
                    id="current-date"
                    v-model="formatted_current_date"
                    type="text"
                    autocomplete="off"
                    disabled
                    class="bg-white"
                />
                <b-input-group-append>
                    <b-form-datepicker
                        v-model="form.from_date"
                        button-only
                        right
                        size="sm"
                        label-no-date-selected="A partir du..."
                        label-prev-year="Année précédente"
                        label-next-year="Année prochaine"
                        label-prev-month="Mois précédent"
                        label-next-month="Mois prochain"
                        label-current-month="Mois actuel"
                        label-help="Vous pouvez utiliser les flèches du clavier pour naviguer"
                        start-weekday="1"
                        aria-controls="current-date"
                        locale="fr"
                        @context="formatCurrentDate"
                    >
                    </b-form-datepicker>
                </b-input-group-append>
            </b-input-group>
            <b-button
                variant="success"
                :disabled="form.from_date === null"
                @click="saveAction"
            >
                Enregistrer
            </b-button>
            <b-button variant="secondary" @click="hideModal">
                Annuler
            </b-button>
        </b-modal>
    </div>
</template>

<script>
import TableFormHandler from '../../../../common/mixins/TableFormHandler.vue'
import ToastHandler from '../../../invoicing/mixins/ToastHandler.vue'

export default {
    name: 'DurationForm',

    mixins: [TableFormHandler, ToastHandler],

    props: {
        action: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            form: {
                from_date: null,
            },
            formatted_current_date: '',
        }
    },

    created() {
        this.align = 'right'
        this.form.from_date = new Date()
    },

    methods: {
        handleNewDuration() {
            this.$refs['apply-duration-modal'].show()
        },
        async saveAction() {
            this.showRecordingToast()
            try {
                const response = await this.$axios.put(
                    `/clientActions/${this.action.id}/duration`,
                    this.form
                )
                this.handleSuccess()
                this.handleRecordingResponse(response.data.meta)
                this.hideModal()
                this.$emit('duration-updated')
            } catch (error) {
                this.handleError()
                console.log(error)
            }
        },
        initForm() {
            this.form.duration = this.action.duration.toFixed(2)
        },
        setInitialKey() {
            this.key = `duration${this.action.id}`
        },
        unFocus() {
            this.$refs.duration.blur()
        },
        hideModal() {
            this.$refs['apply-duration-modal'].hide()
        },
        formatCurrentDate(ctx) {
            this.formatted_current_date = ctx.selectedFormatted
        },
    },
}
</script>

<style scoped>
.form-control-sm {
    height: 20px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    font-size: 12px;
}
</style>
